import { TsColorUtils } from 'tsui/utils/ts-color.utils';

// Shared ag-grid cell-flash timing (ms), spread into `gridApi.flashCells(...)` to highlight cells
// that were just updated. Keeps the flash consistent across tables.
export const CELL_FLASH_CONFIG = {
  flashDuration: 250,
  fadeDuration: 500,
} as const;

export namespace CommonTableStylingFunctions {
  export function applyConditionalStyling(params: any): Record<string, any> {
    const colField = params.colDef?.field;

    if (!colField) return;

    const style = params.data?.meta?.[colField]?.conditional_styling;

    if (!style) return;

    return TsColorUtils.applyConditionalStyling(style?.color, style?.is_bold);
  }
}
